<template>
	<div class="sc-detail">
		<div class="sc-head">
			<v-icon small color="primary" class="mr-1">mdi-truck-delivery-outline</v-icon>
			<span class="sc-head-title">{{ metodo || 'Metodo non trovato' }}</span>
			<span class="sc-muted ml-1">→</span>
			<Bandiera :codice="item.country" class="ml-1" />
			<span class="sc-head-title">{{ nomePaese(item.country) }}</span>
			<span class="sc-muted">· {{ zona(item) }}</span>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('edit')"><v-icon left x-small>mdi-pencil-outline</v-icon>Modifica</v-btn>
			<v-btn x-small text color="error" @click="$emit('delete')"><v-icon left x-small>mdi-delete-outline</v-icon>Elimina</v-btn>
		</div>

		<div class="sc-body">
			<!-- questa fascia, come la legge il cliente -->
			<div>
				<div class="sc-section">Questa tariffa</div>
				<div class="sc-box sc-summary">
					<div class="sc-price">{{ prezzo(item.price) }}</div>
					<div class="sc-facts">
						<div><v-icon x-small class="mr-1">mdi-weight-kilogram</v-icon>{{ pesi(item.min, item.max) }}</div>
						<div><v-icon x-small class="mr-1">mdi-calendar-clock-outline</v-icon>consegna {{ giorni(item.minday, item.maxday) }}</div>
					</div>
				</div>
				<div class="sc-muted sc-small mt-2">
					Un ordine verso {{ nomePaese(item.country) }}<template v-if="item.province || item.cap"> ({{ zona(item) }})</template> che pesa {{ pesi(item.min, item.max) }} vede «{{ metodo }}» a
					{{ prezzo(item.price) }}.
				</div>
			</div>

			<!-- le altre fasce della stessa destinazione e metodo -->
			<div>
				<div class="sc-section">
					Fasce di questa destinazione <span class="sc-muted">· {{ fasce.length }} nella pagina</span>
				</div>
				<div class="sc-box sc-pad">
					<FasceBarra :fasce="barra" />
					<div class="sc-bands mt-2">
						<div v-for="f in fasce" :key="f._id" class="sc-band" :class="{ 'sc-band--on': f._id === item._id }">
							<span class="sc-band-kg">{{ pesi(f.min, f.max) }}</span>
							<span class="sc-muted">{{ giorni(f.minday, f.maxday) }}</span>
							<v-spacer></v-spacer>
							<strong>{{ prezzo(f.price) }}</strong>
						</div>
					</div>
					<div v-for="(p, i) in problemi" :key="i" class="sc-warn mt-2"><v-icon x-small color="warning" class="mr-1">mdi-alert-outline</v-icon>{{ p.testo.replace(/Fascia \d+: /, '') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FasceBarra from './FasceBarra.vue';
import Bandiera from './Bandiera.vue';
import { nomePaese, prezzo, giorni, pesi, zona, problemiFasce } from './formato';

// dettaglio di una tariffa nella lista: riepilogo e fasce della stessa destinazione presenti nella pagina
export default {
	name: 'ShippingCostDetail',
	components: { FasceBarra, Bandiera },
	props: {
		item: { type: Object, required: true },
		metodo: { type: String, default: '' },
		// righe della pagina corrente
		pagina: { type: Array, default: () => [] },
	},
	computed: {
		fasce() {
			const stessa = f => f._method === this.item._method && f.country === this.item.country && (f.province || '') === (this.item.province || '') && (f.cap || '') === (this.item.cap || '');
			const elenco = this.pagina.filter(stessa);
			if (!elenco.some(f => f._id === this.item._id)) elenco.push(this.item);
			return elenco.slice().sort((a, b) => (Number(a.min) || 0) - (Number(b.min) || 0));
		},
		problemi() {
			return problemiFasce(this.fasce);
		},
		barra() {
			return this.fasce.map(f => ({ ...f, chiave: f._id, attiva: f._id === this.item._id }));
		},
	},
	methods: { nomePaese, prezzo, giorni, pesi, zona },
};
</script>

<style scoped>
.sc-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.sc-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.sc-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.sc-body {
	display: grid;
	grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
	gap: 16px;
	padding: 12px;
}
.sc-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.sc-muted {
	color: #5f6b7a;
	font-weight: 400;
	text-transform: none;
	letter-spacing: 0;
}
.sc-small {
	font-size: 12px;
}
.sc-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
}
.sc-pad {
	padding: 10px 12px;
}
.sc-summary {
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 12px 14px;
}
.sc-price {
	font-size: 24px;
	font-weight: 700;
	color: #01579b;
	white-space: nowrap;
}
.sc-facts {
	font-size: 14px;
	line-height: 1.7;
}
.sc-bands {
	font-size: 13px;
}
.sc-band {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 4px 6px;
	border-radius: 6px;
}
.sc-band--on {
	background: #eef4fd;
}
.sc-band-kg {
	font-weight: 500;
	min-width: 110px;
}
.sc-warn {
	padding: 6px 8px;
	border-radius: 6px;
	background: #fff6e5;
	color: #7a4a00;
	font-size: 12px;
}
@media (max-width: 1023px) {
	.sc-body {
		grid-template-columns: 1fr;
	}
}
@media (max-width: 768px) {
	.sc-body {
		padding: 8px;
	}
}
</style>
